import { render, staticRenderFns } from "./ShoppingForm.vue?vue&type=template&id=78ec51c6&scoped=true&"
import script from "./ShoppingForm.vue?vue&type=script&lang=js&"
export * from "./ShoppingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec51c6",
  null
  
)

export default component.exports